export default __webpack_public_path__ + "static/media/features_left_bg.7b7dae0e.svg";